import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Card from '../Card/Card';
import { rolloverTypes } from '../../flows/shared/utils';
import IndirectIcon from '../../images/indirect-rollover.png';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const IndirectRolloverCard = () => {
  const { next } = useContext(FlowContext);

  return (
    <Card
      id="indirectRolloverCard"
      icon={IndirectIcon}
      title={<div>Indirect Rollover</div>}
      subtitle={
        <div>
          I already have a check
          <br />
          payable to me from my plan
          <br />
          provider
          <br />
        </div>
      }
      learnMore
      learnMoreType={rolloverTypes.INDIRECT}
      buttonText="Choose this option"
      buttonFunction={next(rolloverTypes.INDIRECT)}
      buttonID={generateGeneralTestID('Card', 'IndirectTypeButton')}
      cardID={generateGeneralTestID('Card', 'IndirectTypeCard')}
    />
  );
};

export default IndirectRolloverCard;
